define('features/offlineMessage/offlineMessage',['jquery'], function ($) {

    return function(connectivity, getField) {

        var self = this;

        self.noConnectionMessage = getField('no_connection_title');

        connectivity.isOnline.subscribe(function (isOnline) {
            $(document.body).toggleClass('offline', !isOnline);
        });
    };
});



